<template>
  <div class="g_panel subscribe" :class="{ 'darkmode': darkMode }" >
    <!-- header -->
    <div class="header g_panel-header">
      <span class="back icon-back" role="button" aria-label="返回" tabindex="0" @click.stop="backHandler" />
      <h1 class="title">
        <img :src="require('@/assets/about/logo_s@2x.png')" alt="图标" class="taglogo">
        Subscribetion
      </h1>
    </div>
    <!-- end header -->
    <div class="subscribe-con" ref="wrapper">
      <canvas class="canvas" ref="canvas"></canvas>
      <img hidden :src="require('@/assets/login/star_bg.png')" ref="starBg" alt="star">
      <img hidden :src="require('@/assets/login/star_bg_darkmode.png')" ref="starBg_darkmode" alt="star">
      <div class="con g_scroll">
        <img :src="require('@/assets/subscribe/logo-text@2x.png')" v-if="!darkMode" alt="logo" class="logo">
        <img :src="require('@/assets/subscribe/logo-text_white@2x.png')" v-else alt="logo" class="logo">
        <div class="list">
          <div class="item">
            <img :src="require('@/assets/subscribe/free@2x.png')" alt="pic" class="pic">
            <div class="price">
              <div class="num">$0</div>
              <div class="type">Free</div>
            </div>
            <div class="privilege">
              <div class="pitem">
                <i class="icon-check-circle"></i>
                自动同步Github Star分类
              </div>
              <div class="pitem">
                <i class="icon-check-circle"></i>
                创建分类（5个）
              </div>
              <div class="pitem">
                <i class="icon-check-circle"></i>
                分享整个分类
              </div>
              <div class="pitem">
                <i class="icon-check-circle"></i>
                使用各种ICON
              </div>
            </div>
          </div>
           <div class="item">
            <img :src="require('@/assets/subscribe/pro1@2x.png')" alt="pic" class="pic">
            <div class="price" v-if="productMap.month">
              <div class="num">
                ${{NP.divide(productMap.month.unit_amount_decimal, 100)}}
                <div class="year">/1年</div>
              </div>
              <div class="type">Pro</div>
            </div>
            <div class="privilege">
              <div class="pitem">
                <i class="icon-check-circle"></i>
                自动同步Github Star分类
              </div>
              <div class="pitem">
                <i class="icon-check-circle"></i>
                创建分类 （<em class="strong">无限</em>）
              </div>
              <div class="pitem">
                <i class="icon-check-circle"></i>
                分享整个分类
              </div>
              <div class="pitem">
                <i class="icon-check-circle"></i>
                使用各种ICON
              </div>
              <div class="pitem">
                <i class="icon-check-circle"></i>
                更多Feature
              </div>
            </div>
            <div class="btn" :class="{btn_loading: loading || monthLoading}" @click="createNewOrder('month', productMap.day.id)">
              <div v-if="loading || monthLoading" class="g_loading icon-loading"></div>
              <span v-else>马上订阅</span>
            </div>
          </div>
           <div class="item">
            <div class="discount">80% OFF</div>
            <img :src="require('@/assets/subscribe/pro2@2x.png')" alt="pic" class="pic">
            <div class="price" v-if="productMap.year">
              <div class="num">
                ${{NP.divide(productMap.year.unit_amount_decimal, 100)}}
                <div class="year">/1年</div>
              </div>
              <div class="type">Pro</div>
            </div>
            <div class="privilege">
              <div class="pitem">
                <i class="icon-check-circle"></i>
                自动同步Github Star分类
              </div>
              <div class="pitem">
                <i class="icon-check-circle"></i>
                创建分类（<em class="strong">无限</em>）
              </div>
              <div class="pitem">
                <i class="icon-check-circle"></i>
                分享整个分类
              </div>
              <div class="pitem">
                <i class="icon-check-circle"></i>
                使用各种ICON
              </div>
              <div class="pitem">
                <i class="icon-check-circle"></i>
                更多Feature
              </div>
            </div>
            <div class="btn" :class="{btn_loading: loading || yearLoading}" @click="createNewOrder('year', productMap.year.id)">
              <div v-if="loading || yearLoading" class="g_loading icon-loading"></div>
              <span v-else>马上订阅</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="g_dialogw" @click="payModel.show = false" :class="{g_dialogw_active: payModel.show}"></div>
    <div class="g_dialog dialog_pay">
      <h2 class="title">
        Purchase summary
      </h2>
      <div class="fieldw" v-if="productMap[payModel.type]">
        <div class="product">
          <div class="name">
            <img :src="require('@/assets/subscribe/vvip.svg')" class="title-icon"/>
            {{productMap[payModel.type] && productMap[payModel.type].name}}</div>
          <div class="num">
            x <input type="num" class="num-input" v-model="payModel.num"/>
          </div>
          <div class="price">${{NP.times(payModel.num, productMap[payModel.type].price, useDiscount ? discount : 1)}}</div>
        </div>
        <div class="total">
          <div class="name">
            Total
            <div class="save" v-if="useDiscount">(save {{NP.minus(1,  discount) * 100}}%)</div>
          </div>
          <div class="price">${{NP.times(payModel.num, productMap[payModel.type].price, useDiscount ? discount : 1)}}</div>
        </div>
      </div>
      <div class="btn" @click="createStripeOrder">
        <img :src="require('@/assets/subscribe/stripe@2x.png')" class="icon icon-stripe"/>
        Stripe
        <div v-if="stipeOrderLoading" class="g_loading btn-loading icon-loading"></div>
      </div>
      <div class="btn btn_2" @click="createAlipayOrder">
        <img :src="require('@/assets/subscribe/alipay@2x.png')" class="icon icon-ali"/>
        Alipay
      </div>

      <!-- alipay -->
      <div class="pay-confirm" :class="{'pay-confirm_show': payModel.showConfirm}">
        <img :src="require('@/assets/pay/card.svg')" class="pay-confirm-icon" alt="">
        <div class="pay-confirm-text">是否已经支付完成？</div>
        <div class="pay-confirm-btns">
          <div class="btn" @click="payModel.show = false">取消</div>
          <Btn class="btn btn_blue" :loading="checkLoading" @click.native="checkOrder" label="支付完成"></Btn>
        </div>
      </div>
      <!-- alipay -->

      <!-- success -->
      <div class="pay-confirm pay-confirm_success" :class="{'pay-confirm_show': payModel.showSuccess}">
        <img :src="require('@/assets/pay/vip.svg')" class="pay-confirm-icon pay-confirm-icon_success" alt="">
        <div class="pay-confirm-text">支付成功，感谢您的支持!</div>
        <div class="pay-confirm-text_sub">Little Star会努力做得更好!</div>
        <div class="pay-confirm-btns">
          <router-link :to="{name: 'profile'}" class="btn btn_blue" @click.native="checkOrder">确定</router-link>
        </div>
      </div>
      <!-- success -->

      <!-- fail -->
       <div class="pay-confirm pay-confirm_fail" :class="{'pay-confirm_show': payModel.showFail}">
        <img :src="require('@/assets/pay/err.svg')" class="pay-confirm-icon" alt="">
        <div class="pay-confirm-text">支付未完成</div>
        <div class="pay-confirm-msg" v-if="payModel.errMsg">{{payModel.errMsg}}</div>
        <div class="pay-confirm-text_sub" @click="payErrTip">支付遇到问题?</div>
        <div class="pay-confirm-btns">
          <div class="btn" @click="payModel.showFail = false">返回</div>
        </div>
      </div>
      <!-- fail -->

      <div class="pay-confirm pay-confirm_stripe" :class="{'pay-confirm_show': payModel.showStripe}">
        <div class="stripe-confirm-title">
          <div class="back icon-back" @click="payModel.showStripe = false"></div>
          <img :src="require('@/assets/subscribe/stripe@2x.png')" class="icon icon-stripe"/>
          Stripe
        </div>
        <div class="stripe-confirm-filed">
          <label for="email" class="stripe-confirm-label">Email</label>
          <input type="email" class="stripe-confirm-input">
        </div>
        <div class="stripe-confirm-filed">
          <label for="card" class="stripe-confirm-label">Card</label>
          <div  class="stripe-confirm-input" id="stripe-card-element"></div>
        </div>

        <div class="stripe-confirm-btn" @click="stripeConfirm" v-if="payModel.showStripe">
          支付 <span class="num">${{NP.times(payModel.num, productMap[payModel.type].price, useDiscount ? discount : 1)}}</span>
          <div class="g_loading icon-loading" v-if="stripeConfirmLoading"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Star from '@/util/star'
import { HttpRoot, ContactEmail } from '@/config/'
import Btn from '@/components/Btn'
const NP = require('number-precision')

export default {
  components: {
    Btn,
  },
  mounted() {
    this.canvasInit()
    this.getPrices()
    this.getStripeKey()
    window.addEventListener('resize', this.canvasInit)
    this.$on('show', () => { this.show = true })
  },
  watch: {
    darkMode() {
      this.canvasInit()
    },
  },
  data() {
    return {
      loading: false,
      monthLoading: false,
      yearLoading: false,
      canvasPxs: [],
      canvasConfig: null,
      timer: null,
      backUpIng: false,
      show: false,
      discount: 0.8,
      productMap: {
      },
      payModel: {
        show: false,
        type: '',
        num: 1,
        showConfirm: false,
        showSuccess: false,
        showFail: false,
        errMsg: '',
        showStripe: false,
      },
      NP,
      checkLoading: false,
      stripe: '',
      stripeClientKey: '',
      stripeclientSecret: '',
      stipeOrderLoading: false,
      stripeConfirmLoading: false,
      stripeCard: null,
    }
  },
  computed: {
    useDiscount() {
      const product = this.productMap[this.payModel.type]
      console.log(product && this.payModel.num > product.discountBaseNum)
      return product && this.payModel.num >= product.discountBaseNum
    },
    ...mapState({
      user: state => state.user.user,
    }),
  },
  methods: {
    ...mapMutations({
      setDarkMode: 'setDarkMode',
    }),
    ...mapActions({
      getUserInfo: 'user/getUserInfo',
    }),
    getProducts() {
      this.$http.get('/pay/products').then((res) => {
        this.productMap = res
      })
    },
    getPrices() {
      this.loading = true
      this.$http.get('/pay/stripe/price').then((res) => {
        this.productMap = res.data
        this.loading = false
      })
    },
    createAlipayOrder() {
      this.payModel.showConfirm = true
      window.open(HttpRoot + `/pay/ali/order?orderType=${this.payModel.type}&num=${this.payModel.num}`)
    },
    checkOrder() {
      this.checkLoading = true
      this.$http.get('/pay/ali/check').then((res) => {
        if (res.success) {
          this.getUserInfo()
          this.payModel.showSuccess = true
        } else {
          this.payModel.showFail = true
        }
      }).finally(() => {
        this.checkLoading = false
      })
    },
    getStripeKey() {
      return this.$http.get('/pay/stripe/key').then((res) => {
        this.stripeClientKey = res.key
        this.stripe = new Stripe(this.stripeClientKey)
      })
    },
    createNewOrder(type, id) {
      if (!id) return
      if (type === 'month') this.monthLoading = true
      if (type === 'year') this.yearLoading = true

      // this.stipeOrderLoading = true
      this.$http.post('/pay/stripe/order', {
        priceId: id,
      }).then((res) => {
        // this.stripeclientSecret = res.client_secret
        // this.payModel.showStripe = true
        // const s = new Stripe()
        const stripe = new Stripe(this.stripeClientKey)
        stripe.redirectToCheckout({
          sessionId: res.id,
        }).then((res) => {
          console.log(res)
        })
      }).finally(() => {
        if (type === 'month') this.monthLoading = false
        if (type === 'year') this.yearLoading = false
      })
    },
    createStripeOrder() {
      this.stipeOrderLoading = true
      this.$http.post('/pay/stripe/order', {
        type: this.payModel.type,
        num: this.payModel.num,
      }).then((res) => {
        this.stripe.redirectToCheckout({ sessionId: res.id })
      })
    },
    createStripeOrder2() {
      this.stipeOrderLoading = true
      this.$http.post('/pay/stripe/order', {
        type: this.payModel.type,
        num: this.payModel.num,
      }).then((res) => {
        this.stripeclientSecret = res.client_secret

        this.payModel.showStripe = true
      }).finally(() => {
        this.stipeOrderLoading = false
      })
    },
    initStripeElement() {
      const elements = this.stripe.elements()

      const style = {
        base: {
          color: '#32325d',
          fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4',
          },
          width: '100%',
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a',
        },
      }
      // Create an instance of the card Element.
      this.stripeCard = elements.create('card', {
        style: style,
      })
      // Add an instance of the card Element into the `card-element` <div>.
      this.stripeCard.mount('#stripe-card-element')
    },
    stripeConfirm() {
      this.stripeConfirmLoading = true
      this.stripe
        .confirmCardPayment(this.stripeclientSecret, {
          payment_method: {
            card: this.stripeCard,
            billing_details: { name: this.user.nickName },
          },
        })
        .then((result) => {
          console.log(result)
          if (result.error) {
            this.payModel.showFail = true
            this.payModel.errMsg = result.error.message
          } else {
            // 支付成功
            this.payModel.showSuccess = true
          }
          this.stripeConfirmLoading = false
        })
    },
    order(type) {
      this.payModel.showConfirm = false
      this.payModel.num = 1
      this.payModel.show = true
      this.payModel.type = type
      this.showSuccess = false
      this.showFail = false
    },
    backHandler() {
      this.$router.back()
    },
    changeSetting(key, value) {
      this.$http.put('/setting/', {
        key,
        value,
      }).then(() => {
        this.setAutoBackup(value)
        this.$emit('startAnimate', 300)
      })
    },
    // 支付遇到问题提示
    payErrTip() {
      this.$toast({
        isConfirm: true,
        msg: `请联系${ContactEmail}`,
      })
    },
    backUpData() {
      if (!this.user.email) {
        this.$toast({
          isConfirm: true,
          msg: '你还没有设置Email，立刻去设置？',
        }).then(() => {
          this.$router.push({ name: 'email' })
        })
        return
      }
      this.backUpIng = true
      this.$emit('startAnimate')
      this.$http.get('/setting/backup').then(() => {
        this.$toast({
          msg: `已发送备份到${this.user.email}`,
        })
        this.$emit('startAnimate', 300)
        this.backUpIng = false
      }).catch(() => {
        this.backUpIng = false
      })
    },
    changeEmail() {
      this.$router.push({ name: 'email' })
    },
    draw() {
      this.canvasConfig.con.clearRect(0, 0, this.canvasConfig.width, this.canvasConfig.height)
      for (let e = 0; e < this.canvasPxs.length; e++) {
        this.canvasPxs[e].fade()
        this.canvasPxs[e].move()
        this.canvasPxs[e].draw()
      }
    },
    canvasInit() {
      console.log('canvasInit')
      const con = this.$refs.canvas.getContext('2d')
      console.log(this.darkMode)
      const starBg = this.darkMode ? this.$refs.starBg_darkmode : this.$refs.starBg
      this.canvasConfig = {
        starBg,
        con,
        width: this.$refs.wrapper.offsetWidth,
        height: this.$refs.wrapper.offsetHeight,
        numberObject: 8e3,
        numberBall: 100,
        pulsion: 16,
        speedX: 1,
        speedY: 1,
        // colorRect: 'rgba(204,204,204,',
        colorRect: 'rgba(254,212,120,',
        opacityRect: 0.9,
        rint: 30,
        radius: 70,
      }
      this.$refs.canvas.width = this.canvasConfig.width
      this.$refs.canvas.height = this.canvasConfig.height
      for (let e = 0; e < this.canvasConfig.numberBall; e++) {
        this.canvasPxs[e] = new Star(this.canvasConfig)
        this.canvasPxs[e].reset()
      }
      clearInterval(this.timer)
      this.timer = setInterval(this.draw.bind(this), this.canvasConfig.rint)
    },
  },
}
</script>

<style lang="scss" scoped>
.canvas{
  width: 100%;
  height: 100%;
  position: absolute;
  left:0;
  top:0;
  z-index:1;
  color:#FBFBFB;
}
.subscribe-con{
  position: relative;
  min-height: 800px;
  height: calc(100vh - 52px);
}
.con{
  z-index: 10;
  box-sizing: border-box;
  width: 100%;
  padding-top: 32px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: calc(100vh - 52px);
}
.logo{
  height: 122px;
  width: 111px;
  display: block;
  margin: 100px auto 100px;
}
.list{
  display: flex;
  justify-content: center;
  padding-bottom: 100px;
  .item{
    background: rgba(255, 255, 255, 0.63);
    background-image: linear-gradient(180deg, #FBFBFB 0%, #F6F5F5 100%);
    border: 1px solid #F1F1F1;
    box-shadow: 0 6px 22px 5px rgba(150,150,150,0.26);
    border-radius: 16px;
    margin: 0 32px;
    width: 256px;
    height: 460px;
    padding-top: 32px;
    transition: 0.2s ease;
    position: relative;
    &:hover{
      transform: translate(0, -10px);
    }
  }
  .pic{
    display: block;
    margin: 0 auto 36px;
  }
  .item:nth-child(1) .pic{
    // height: 61px;
    width: 130px;
  }
  .item:nth-child(2) .pic{
    height: 90px;
    width: 130px;
  }
  .item:nth-child(3) .pic{
    height: 90px;
    width: 130px;
  }
  .price{
    display: flex;
    justify-content: center;
    padding-bottom: 32px;
    position: relative;
    .num{
      font-size: 46px;
      color: #343434;
      line-height: 22px;
      font-weight: bold;
      display: flex;
    }
    .year{
      padding-top: 8px;
      font-size: 14px;
      color: #414141;
      line-height: 24px;
    }
    .type{
      margin-left: 4px;
      color: #2E7FFF;
      font-weight: bold;
      font-size: 14px;
      color: #2E7FFF;
    }
  }
  .discount{
    background: #FB6967;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    top: 8px;
    right: 8px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    padding: 4px;
    position: absolute;
  }
  .privilege{
    padding-left: 24px;
  }
  .pitem{
    color: #3C3C3C;
    line-height: 20px;
    margin-bottom: 14px;
    font-size: 16px;
    .strong{
      font-style: normal;
      color: #FF915D;
    }
    .icon-check-circle{
      display: inline-block;
      color: #2E7FFF;
      margin-right: 4px;
    }
  }

  .btn{
    margin: 32px auto 0;
    width: 180px;
    background-image: linear-gradient(180deg, #2E7FFF 0%, #2076FF 100%);
    box-shadow: 0 2px 7px 0 rgba(0,0,0,0.14);
    border-radius: 999px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .icon{
      margin-left: 4px;
    }
    &:hover{
      background-image: linear-gradient(180deg, #2772E9 0%, #216BE0 100%);
    }
  }
  .btn_loading{
    opacity: 0.6;
  }
}

// .g_dialog
.dialog_pay{
  background: #FFFFFF;
  box-shadow: 0 0 6px 1px rgba(131,131,131,0.50);
  border-radius: 12px;
  // height: 299px;
  width: 436px;
  z-index: 100;
  padding: 24px 24px;
  box-sizing: border-box;
  overflow: hidden;
  .title{
    font-size: 20px;
    color: #2C2C2C;
    text-align: left;
    font-weight: bold;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    margin-top: 0;
  }
  .fieldw{
    font-size: 14px;
    margin-bottom: 88px;
    .icon{
      width: 16px;
      margin-right: 4px;
      display: block;
    }
    .product{
      display: flex;
      line-height: 20px;
      justify-content: space-between;
      border-bottom: 1px solid #DCDCDC;
      margin-bottom: 24px;
      padding-bottom: 8px;
      color: #4E4E4E;
    }
    .num{
      display: flex;
      align-items: center;
    }
    .num-input{
      text-align: center;
      color: #4E4E4E;
      height: 18px;
      width: 34px;
      box-sizing: border-box;
      background: #FFFFFF;
      border: 1px solid #CCCCCC;
      border-radius: 4px;
      margin-left: 6px;
    }
  }
  .total{
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    .name{
      display: flex;
    }
    .save{
      margin-left: 4px;
      color: #FF6969;
    }
    .price {
      color: #2671FF;
    }
  }
  .btn{
    background: #FFFFFF;
    border: 1px solid #abe0ff;
    border-radius: 8px;
    font-size: 14px;
    color: #4F4F4F;
    text-align: left;
    height: 45px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    // box-shadow: 0 0 15px 1px rgba(171,171,171,0.17);
    margin-bottom: 12px;
    transition: 0.2s ease-in;
    cursor: pointer;
    font-weight: bold;
    &:hover{
      // border-color: #2E7FFF;
      box-shadow: 0 0 15px 1px rgba(171,171,171,0.37);
    }
    .icon-ali{
      width: 28px;
      height: 28px;
    }
    .icon{
      margin-right: 8px;
    }
    .icon-stripe{
      width: 35px;
      height: 23px;
    }
  }
  .btn_2{
    margin-bottom: 0;
  }
  .btn-loading{
    margin-left: 4px;
    color: #9e9e9e;
  }

  // pay-confirm
  .pay-confirm{
    border-radius: 12px;
    height: 100%;
    width: 100%;
    background: #fff;
    transition: 0.2s ease;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
    transform: translateX(100%);
  }
  .pay-confirm_show{
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
  .pay-confirm-icon{
    width: 42px;
    display: block;
    margin: 0 auto 24px;
  }
  .pay-confirm-icon_success{
    width: 43px;
  }
  .pay-confirm-text{
    font-size: 20px;
    color: #3B3B3B;
    text-align: center;
    font-weight: bold;
  }
  .pay-confirm-text_sub{
    font-size: 14px;
    line-height: 20px;
    color: #3B3B3B;
    text-align: center;
    margin-top: 8px;
    font-weight: normal;
  }
  .pay-confirm_fail{
    z-index: 100;
    .pay-confirm-text_sub{
      color: #35A5E0;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
  }
  .pay-confirm_success{
    z-index: 100;
  }
  .pay-confirm-btns{
    display: flex;
    justify-content: center;
    margin-top: 52px;
    .btn{
      height: 42px;
      width: 118px;
      box-sizing: border-box;
      line-height: 42px;
      border: 1px solid #9e9e9e;
      background: #fff;
      color: #5a5a5a;
      box-shadow: 0 0 15px 1px rgba(171,171,171,0.17);
      border-radius: 8px;
      margin: 0 16px;
    }
    .btn_blue {
      text-decoration: none;
      background: #35A5E0;
      border: 1px solid #35A5E0;
      color: #fff;
    }
  }

  //pay-confirm
  .pay-confirm_stripe{
    padding-top: 16px;
    .stripe-confirm-title{
      display: flex;
      justify-content: center;
      align-items: center;
      color: #595959;
      // padding: 37px 0 16px;
      position: absolute;
      top: 32px;
      left: 32px;
      .back{
        margin-right: 8px;
        cursor: pointer;
      }
      .icon{
        width: 28;
        height: 16px;
        margin-right: 4px;
      }
    }
    .stripe-confirm-filed{
      margin: 0 auto 16px;
    }
    .stripe-confirm-label{
      font-size: 14px;
      color: #B4B4B4;
      margin-bottom: 4px;
      display: block;
    }
    .stripe-confirm-input{
      background: #FFFFFF;
      border: 1px solid #E9E9E9;
      border-radius: 4px;
      height: 42px;
      width: 320px;
      padding: 11px 6px;
      border-radius: 4px;
      box-sizing: border-box;
    }
    .stripe-confirm-btn{
      background-image: linear-gradient(180deg, #3DB2EF 0%, #35A5E0 100%);
      box-shadow: 0 0 15px 1px rgba(171,171,171,0.17);
      border-radius: 8px;
      height: 48px;
      width: 316px;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 16px;
      justify-content: center;
      margin-top: 16px;
    }
  }
}
/* darkmode */
.darkmode{
  .list{
    .item{
      background-image: linear-gradient(180deg, #333232 0%, #2B2B2B 99%);
      box-shadow: 0 0 20px 0 rgba(32,32,32,0.50);
      border-radius: 16px;
      border: 1px solid #3c3c3c;
    }
    .pitem{
      color: #fff;
    }
    .num{
      color: #fff;
    }
    .year{
      color: #fff;
    }
  }
}
</style>
